/* unplugin-vue-components disabled */import { render } from "./Base.vue?vue&type=template&id=7088ff20"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__